module.exports = __webpack_public_path__ + "static/media/Rinaldi.e2cba234.png";